// Bakım-Onarım (Ödenek + Doğrudan Temin) detay kartları için ortak biçimleyiciler
import { tesisTuruText } from '../../../utils/tesisTuru';

export const ALIM_TURU_TR = {
  '22/a': '22/a', '22/c': '22/c', '22/d': '22/d',
  dogrudan_temin: 'Doğrudan Temin', acik_ihale: 'Açık İhale', pazarlik: 'Pazarlık',
};

// Ödenek durumu → rozet rengi
export const ODENEK_DURUM_TONE = {
  'GELDİ': 'bg-emerald-500/20 text-emerald-300 border-emerald-500/50',
  'GELDİ-ÖDENDİ': 'bg-blue-500/20 text-blue-300 border-blue-500/50',
  'GELMEDİ': 'bg-amber-500/20 text-amber-300 border-amber-500/50',
  'İPTAL EDİLDİ': 'bg-red-500/20 text-red-300 border-red-500/50',
  'EMANETE ALINDI': 'bg-purple-500/20 text-purple-300 border-purple-500/50',
};

export const fmtTarih = (d) => {
  if (!d) return '';
  const m = String(d).match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? `${m[3]}.${m[2]}.${m[1]}` : String(d);
};

// "28084,50" | "1.250,00" → 28084.5
export const parseTL = (v) => {
  if (v === null || v === undefined || v === '') return 0;
  const n = parseFloat(String(v).replace(/[^0-9,]/g, '').replace(',', '.'));
  return isNaN(n) ? 0 : n;
};

// 28084.5 → "28084,50" (displayMoney'nin beklediği biçim)
export const toTLString = (n) => (Number(n) || 0).toFixed(2).replace('.', ',');

export const alimTuruLabel = (v) => ALIM_TURU_TR[v] || v || '';
export const tesisTuruLabelText = (v) => tesisTuruText(v);

export const butceTertibiText = (r) => (Array.isArray(r?.butce_tertibi_list) && r.butce_tertibi_list.length ? r.butce_tertibi_list : [r?.butce_tertibi].filter(Boolean));

// Firma teklifleri: [{no, adi, teklif}] — sadece adı veya teklifi girilmiş olanlar
export const firmaTeklifleri = (r) => [1, 2, 3, 4]
  .map(i => ({ no: i, adi: r?.[`firma${i}_adi`] || '', teklif: r?.[`firma${i}_teklif`] || '' }))
  .filter(f => f.adi || f.teklif);

export const enDusukTeklif = (teklifler) => {
  const dolu = teklifler.filter(f => parseTL(f.teklif) > 0);
  if (!dolu.length) return null;
  return dolu.reduce((min, f) => (parseTL(f.teklif) < parseTL(min.teklif) ? f : min), dolu[0]);
};
